module.exports = __webpack_public_path__ + "img/proses_kargo.6c020529.svg";